<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    v-if="canSee || is_version"
    class="vs-sidebar--item"
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
  >
    <router-link
      tabindex="-1"
      v-if="to"
      exact
      :class="[{ 'router-link-active': activeLink }]"
      :to="to"
      :target="target"
    >
      <span v-if="material_icon" class="material-icons w-5 h-5 m-1">
        {{ material_icon }}
      </span>
      <!-- <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" /> -->
      <feather-icon
        v-if="featherIcon"
        :class="{ 'w-3 h-3': iconSmall }"
        :icon="icon"
      />

      <slot />
    </router-link>

    <a v-else :target="target" :href="href" tabindex="-1">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </a>
    <!-- <div v-if="is_version" class="footer-build">
      <p>Build {{ getVersion }}</p>
    </div> -->
  </div>
</template>

<script>
import constant from "../../../services/constant";
export default {
  name: "v-nav-menu-item",
  props: {
    is_version: { type: Boolean, default: false },
    icon: { type: String, default: "" },
    material_icon: { type: String, default: "" },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: "material-icons" },
    href: { type: [String, null], default: "#" },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: "_self" },
    isDisabled: { type: Boolean, default: false },
    user_role: { type: String, default: "" },
    name: { type: String, default: "" },
    user_permissions: { type: Object },
  },

  computed: {
    getVersion() {
      console.log(constant.build_version);

      return constant.build_version;
    },
    canSee() {
      // this.$acl.check(this.$store.state.AppActiveUser.userRole);
      // return this.to
      //   ? this.$acl.check(this.$router.match(this.to).meta.rule)
      //   : true;
// return true;
      if (this.user_role == "Owner") {
        return true;
      }
      if (this.name) {
        let item_name=this.name.toLowerCase()
       
      console.log(this.name);
      console.log(this.user_permissions);

        if (this.name && (this.user_permissions[this.name]||this.user_permissions[item_name])) {
          if(this.user_permissions[this.name])
          return this.user_permissions[this.name]["read"];
          if(this.user_permissions[item_name])
          return this.user_permissions[item_name]["read"];

        }
      }
      // for (const property in this.user_permissions) {
      //   if (
      //     property.includes(this.name) &&
      //     this.user_permissions[property]["read"]
      //   ) {
      //     console.log(
      //       property.includes(this.name) &&
      //         this.user_permissions[property]["read"]
      //     );
      //     can_see=property.includes(this.name) &&
      //         this.user_permissions[property]["read"]
      //   }
      // }
    },
    activeLink() {
      return !!(
        (this.to === this.$route.path ||
          this.$route.meta.parent === this.slug) &&
        this.to
      );
    },
  },
};
</script>
<style scoped lang="scss">
span.material-icons {
  font-size: 22px !important;
}
.footer-build {
  position: absolute;
  bottom: 5px;
  width: 90%;
  p {
    text-align: center;
    font-size: 12px;
  }
}
</style>

